import { useEffect } from 'react'

const PIXEL_ID = '2021795741838094'
const SCRIPT_ID = 'meta-pixel-script'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

export function useMetaPixel(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return

    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args)
        } else {
          fbq.queue?.push(args)
        }
      } as NonNullable<Window['fbq']>

      fbq.queue = []
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'

      window.fbq = fbq
      window._fbq = fbq
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)

      const noscript = document.createElement('noscript')
      const image = document.createElement('img')
      image.height = 1
      image.width = 1
      image.alt = ''
      image.style.display = 'none'
      image.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
      noscript.appendChild(image)
      document.head.appendChild(noscript)
    }

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  }, [])
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
